import React from 'react';
import styled from 'styled-components';
import { cornerStyleInterpolationFactory } from '../lib/cornerStyle';
import { SkeletonBlock, SkeletonText } from '@nucleus/web-theme-elements';

export const PostExpandedListItemSkeleton = (): JSX.Element => {
  return (
    <Container>
      <MediaPlaceholder />
      <Meta>
        <SkeletonText width="20%" style={{ height: 10, marginBottom: 12 }} />
        <SkeletonText width="85%" style={{ height: 20, marginBottom: 8 }} />
        <SkeletonText width="65%" style={{ height: 20, marginBottom: 16 }} />
        <TextBlock>
          <SkeletonText width="100%" style={{ height: 12, marginBottom: 4 }} />
          <SkeletonText width="95%" style={{ height: 12, marginBottom: 4 }} />
          <SkeletonText width="70%" style={{ height: 12, marginBottom: 16 }} />
        </TextBlock>
        <SkeletonText width="30%" style={{ height: 10, marginBottom: 20 }} />
        <SkeletonBlock style={{ width: 140, height: 44, borderRadius: 8 }} />
      </Meta>
    </Container>
  );
};

const Container = styled.div`
  padding: 25px;
  border-radius: ${cornerStyleInterpolationFactory({
    square: '0px',
    rounded: '18px',
    pill: '40px',
  })};
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: 1200px) {
    flex-direction: row;
    align-items: center;
  }
`;

const MediaPlaceholder = styled(SkeletonBlock)`
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: ${cornerStyleInterpolationFactory({
    square: '0px',
    rounded: '12px',
    pill: '25px',
  })};

  @media (min-width: 1200px) {
    max-width: 650px;
    flex: 2 1 650px;
  }
`;

const Meta = styled.div`
  flex: 1 2 300px;
  max-width: 85%;
  padding-left: 4.6%;
  padding-top: 24px;

  @media (min-width: 1200px) {
    max-width: 860px;
    padding-top: 0;
    padding-bottom: 0;
  }

  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const TextBlock = styled.div``;
